import { Input } from "@/components/ui/Input";
import { Search } from "lucide-react";
import { HistoryList, type ChatHistoryItem } from "./HistoryList";
import { UserAuthButton } from "./UserAuthButton";
import { NewChat } from "./NewChat";
import { Myorder } from "./Myorder";
import { AgentMenu } from "./AgentMenu";
import { MatchSettingsMenu } from "./MatchSettingsMenu";
import { useState } from "react";
// 当前文件注释部分为删除对话功能，后续根据需要调整

// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogFooter,
//   DialogHeader,
//   DialogTitle,
// } from "@/components/ui/Dialog";
// import { toast } from "sonner";
// import { Search, AlertTriangle } from "lucide-react";
// import { Button } from "@/components/ui/Button";

interface SidebarContentProps {
  historyData: ChatHistoryItem[];
  onLoadHistory?: (sessionId: number) => void;
  onClearMessages?: () => void;
  onClose?: () => void;
  loadMore: () => void;
  isLoadingMore?: boolean;
  isReachingEnd?: boolean;
  selectedChat: number | null;
  setSelectedChat: (id: number | null) => void;
  onNavigate?: (path: string) => void;
}

export function SidebarContent({
  historyData,
  onLoadHistory,
  onClearMessages,
  onClose,
  loadMore,
  isLoadingMore,
  isReachingEnd,
  selectedChat,
  setSelectedChat,
  onNavigate,
}: SidebarContentProps) {
  const handleSafeClose = onClose || (() => {});
  // const [showDeleteChatsDialog, setShowDeleteChatsDialog] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredHistoryData = searchQuery.trim()
    ? historyData.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : historyData;

  // const handleDeleteAllChats = () => {
  //   onClearMessages?.();
  //   handleSafeClose();
  //   setShowDeleteChatsDialog(false);
  //   toast.success("已删除所有对话");
  // };

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    // Threshold: 50px from bottom
    if (scrollHeight - scrollTop - clientHeight < 50) {
      if (!isLoadingMore && !isReachingEnd) {
        loadMore();
      }
    }
  };

  return (
    <div className="flex flex-col h-full w-full bg-background relative overflow-hidden">
      {/* 头部固定区域 */}
      <div className="flex flex-col h-full w-full bg-background overflow-y-auto">
        <div className="flex-shrink-0 bg-background z-10">
          <div className="flex items-center w-full h-8 p-4 mt-2 gap-2">
            <img className="w-8 h-8" src="/avatar.svg" alt="" />
            <span className="text-base text-blue-500">匹配与决策智能体引擎系统V1.0</span>
          </div>

          {/* 搜索框 */}
          <div className="px-3.5 my-2">
            <div className="relative">
              <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="搜索..."
                className="pl-8 text-base font-normal bg-[#F3F3F3] border-none rounded-[1rem] h-9"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="px-2 space-y-1">
            <NewChat
              onClearMessages={onClearMessages}
              onClose={onClose}
              onClearSelection={setSelectedChat}
            />
            <div className="block">
              <Myorder />
            </div>
            <div className="block">
              <AgentMenu onNavigate={onNavigate} />
            </div>
            <div className="block">
              <MatchSettingsMenu onNavigate={onNavigate} />
            </div>
          </div>

          {/* 聊天历史标题 */}
          <div className="flex items-center px-5 mt-3.5">
            <h3 className="text-sm text-[#80838A] font-500">聊天历史</h3>
          </div>
        </div>
        <div
          className="flex-1 overflow-y-auto min-h-0 scrollbar-hide"
          onScroll={handleScroll}
        >
          <HistoryList
            historyData={filteredHistoryData}
            onLoadHistory={onLoadHistory}
            onClose={handleSafeClose}
            selectedChat={selectedChat}
            onSelectChat={setSelectedChat}
          />
          {isLoadingMore && (
            <div className="p-2 text-center text-xs text-muted-foreground">
              加载中...
            </div>
          )}
          {isReachingEnd && historyData.length > 0 && (
            <div className="p-2 text-center text-xs text-muted-foreground">
              没有更多了
            </div>
          )}
        </div>

        <div className="flex-shrink-0 bg-background px-4 py-1 border-t z-10">
          <UserAuthButton />
        </div>
      </div>

      {/* 删除对话确认对话框 */}
      {/* <Dialog
        open={showDeleteChatsDialog}
        onOpenChange={setShowDeleteChatsDialog}
      >
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <AlertTriangle className="w-5 h-5 text-yellow-500" />
              确认删除
            </DialogTitle>
            <DialogDescription>
              你确定要删除所有对话吗？此操作不可恢复。
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => setShowDeleteChatsDialog(false)}
            >
              取消
            </Button>
            <Button variant="destructive" onClick={handleDeleteAllChats}>
              确认删除
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog> */}
    </div>
  );
}
